/* PW Bundle draft-theme-only cart recommendation suppression.
 * Does not change product prices, Shopify discounts, or MAIN theme. */
(function(){
  if(window.__PW_BUNDLE_PREVIEW_CART_GUARD__)return;
  window.__PW_BUNDLE_PREVIEW_CART_GUARD__=true;
  let serial=0, refreshTimeout=0;
  function apply(cart){
    const hasPreview=Array.isArray(cart?.items)&&cart.items.some(item=>
      item?.properties?._pw_preview_bundle === 'true');
    document.documentElement.classList.toggle('pw-bundle-cart-active',Boolean(hasPreview));
  }
  async function refresh(){
    const call=++serial;
    try{
      const root=window.Shopify?.routes?.root||'/';
      const response=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store',
        headers:{Accept:'application/json'}});
      if(!response.ok)return;
      const cart=await response.json();
      if(call===serial)apply(cart);
    }catch(_){}
  }
  function schedule(delay=70){clearTimeout(refreshTimeout);refreshTimeout=setTimeout(refresh,delay);}
  ['ajaxProduct:added','cart:updated','cart:refresh','pw:cart:state'].forEach(name=>
    document.addEventListener(name,(event)=>{
      const cart=event.detail?.cart;
      if(Array.isArray(cart?.items)){
        // Reuse the confirmed cart state instead of requesting /cart.js again.
        ++serial;
        clearTimeout(refreshTimeout);
        apply(cart);
      }else{
        schedule(90);
      }
    }));
  window.addEventListener('pageshow',()=>schedule(0));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>schedule(0),{once:true});
  else schedule(0);
})();
